import React from "react";
import PropTypes from "prop-types";
import ScrollRestore from "core-web/components/ScrollRestore";
import styled from "theme/libs/styled";
import NotificationWrapper from "theme/components/wrappers/NotificationWrapper";

const Wrapper = styled("div")`
    width: 100%;
    min-height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;

    &[data-is-checkout-view="true"] {
        background-color: ${({ theme }) => theme.colors.bg_grey};
    }
`;

const SiteWrapper = ({ children, isCheckoutView }) => (
    <Wrapper data-is-checkout-view={isCheckoutView}>
        <ScrollRestore />
        {children}
        <NotificationWrapper />
    </Wrapper>
);

SiteWrapper.propTypes = {
    children: PropTypes.node.isRequired,
};

export default SiteWrapper;
